import axios            from 'axios'
import itLocale from 'vee-validate/dist/locale/it';
import VeeValidate, { Validator } from 'vee-validate';
import Vue              from 'vue'
import VueAxios         from 'vue-axios'
import VueConfig        from 'vue-config'
import App              from './App.vue'
import Msg              from './components/Msg.vue'
import store            from './store'
import vSelect          from 'vue-select'
import { VueReCaptcha } from 'vue-recaptcha-v3'

import { gtmManager } from './plugins.js'

Vue.config.productionTip = false;

Vue.use(VeeValidate, {classes: true});
Vue.use(gtmManager, {context: 'formSSN'});

const customDictionary = {
  it: {
    messages:{
      date_format: () => 'La data deve essere valida ed antecedente rispetto a quella odierna.',
      before: () => 'La data deve essere antecedente rispetto a quella odierna.'
    }
  }
};

// Override and merge the dictionaries
Validator.localize('it', itLocale);
Validator.localize(customDictionary);

Vue.use(VueAxios, axios);
Vue.use(VueConfig, BookingFormInitData);
Vue.use(VueReCaptcha, { siteKey: BookingFormInitData.siteKey });

// Distribute to components using global mixin
const eventHub = new Vue(); // Single event hub

Vue.mixin({
  data: function () {
    return {
      eventHub: eventHub
    }
  }
});

// Registering global components
Vue.component("Msg", Msg);
Vue.component('v-select', vSelect);

new Vue({
  store,
  render: h => h(App),
}).$mount('#booking-app');

